import { getPlatformLogTk } from './getPlatformLogTk';
import { invokeRegisteredCallbacks } from './providerLoggingCallback';
import { windowProviderDebug } from './debug';
import { getLoadMethod } from './initializeProvidersUtils';
export const PLATFORM_LOG_EVENT = 'trackUIPlatformEvent';
const USER_INTERACTION_LOG_TYPE = 'mosaicUserInteraction';
function isError(error) {
    return error instanceof Error;
}
// This function will translate the error passed to
// trackError into something that can be passed
// into trackEvent with at least a message field.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getErrorInfo(error) {
    // First do a null check, if the error is null,
    // then that itself is an error. Create a new
    // error to use that will then preserve the stack trace.
    // This will prevent the
    // { message: null, stack: null, name: null }
    // entries that we've seen in LogRepo in the past.
    if (error === null) {
        error = new Error('Error passed to trackError was null');
    }
    if (isError(error)) {
        return {
            name: error.name,
            stack: error.stack,
            message: error.message
        };
    }
    // if what's passed through is just a string then
    // just embed it in the message field
    if (typeof error === 'string') {
        return {
            message: error
        };
    }
    // if none of the above conditions match, then call JSON.stringify
    // on the error.  This is done with JSON.stringify since in the past
    // we have seen a lot of `message: [object Object]` entries in LogRepo.
    // example of failures) https://link.indeed.tech/IDASH6WR7KR
    return {
        message: JSON.stringify(error)
    };
}
export class MosaicLogger {
    constructor(mosaicGlobal, logger) {
        this.mosaicGlobal = mosaicGlobal;
        this.logger = logger;
        const script = document.createElement('script');
        const isEvergreenBrowser = 
        // @ts-ignore: supports() is new but real: https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/supports
        (script.supports && script.supports('module')) ||
            'noModule' in script ||
            'nomodule' in script;
        this.isEvergreenBrowser = String(isEvergreenBrowser);
    }
    trackError(logType, error, providerId, data = {}) {
        var _a;
        // Sometimes the error object isn't of type Error,
        // so we need to transform it in order to pass it along
        // to trackEvent
        const errorInfo = getErrorInfo(error);
        if (providerId) {
            windowProviderDebug(providerId, 'Provider Error: ' + JSON.stringify(errorInfo));
        }
        this.trackEvent(Object.assign(Object.assign({ provider: providerId, parentLogId: getPlatformLogTk(this.mosaicGlobal, providerId), canary: providerId && ((_a = this.mosaicGlobal.canaryProviders) === null || _a === void 0 ? void 0 : _a[providerId]) ? 1 : 0, loadMethod: providerId && getLoadMethod(this.mosaicGlobal, providerId), logType }, errorInfo), data));
        const errorTypes = {
            jsuipPlatformInitError: 'platformInitializationError',
            jsuipPlatformLoadError: 'platformLoadError',
            jsuipProviderLoadError: 'providerLoadError',
            jsuipProviderExecutionError: 'providerExecutionError'
        };
    }
    trackEvent(data) {
        invokeRegisteredCallbacks(this.mosaicGlobal, data);
        data.isEvergreenBrowser = this.isEvergreenBrowser;
        this.logger.event.trackEvent(PLATFORM_LOG_EVENT, data);
    }
    trackInteraction(eventType, data) {
        invokeRegisteredCallbacks(this.mosaicGlobal, Object.assign({ logType: USER_INTERACTION_LOG_TYPE }, data));
        this.logger.event.trackEvent(eventType, Object.assign({ logType: USER_INTERACTION_LOG_TYPE }, data));
    }
}
